export default __webpack_public_path__ + "static/media/Tick.148ae42a.svg";